<template>
  <!-- filter menu -->
  <v-menu 
  bottom
  left
  transition="slide-y-transition"
  offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
      text
      small
      v-on="on"
      >
        <v-icon color="text">filter_list</v-icon>
        {{ sortOptions[sortIndex] }}
        <v-icon 
        small
        color="color1"
        :class="['sort-arrow visible transition2s', {'rotate': filters.sortAscending}]">
          arrow_downward
        </v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-item-group 
      v-model="sortIndex"
      mandatory>
        <v-item
          v-for="n in sortOptions"
          :key="n">
          <v-list-item
            v-ripple
            slot-scope="{ active }"
            :selected="active"
            @click="$emit('onSort', n)"
          >
            {{ n }}
            <v-icon 
            small
            color="color1"
            :class="['sort-arrow', {'rotate': active && filters.sortAscending}, {'visible': active }]">
              arrow_downward
            </v-icon>
          </v-list-item>
        </v-item>
      </v-item-group>
    </v-list>
  </v-menu>
  <!-- end filter menu -->
</template>

<script>
export default {
  props: ['sortOptions', 'sortIndex', 'filters']
}
</script>

<style scoped lang="scss">
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
</style>

